<!--
 * @description: 维修状态列表
 * @param: 
 * @return: 
-->
<template>
  <div class="user-management-container">
    <tabel-panel
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="ChangeRepairDetailState"
      :condition="conditionData"
      editType="pop"
      :autoSearch="true"
      :showCancelButton="false"
      @popConfirmButtonClick="popConfirmButtonClick"
      :clickRowSelected="false"
      @customerRowDblClick="customerRowDblClick"
      :popToCustomer="true"
    >
      <template v-slot:tabelTitleRight>
        <downloadButton @buttonClick="exportAlls" style="margin-left: 10px"
          >导出</downloadButton
        >
      </template>
      <template v-slot:maintenanceState="{ data }">
        <span>
          {{ data.row.State }}
        </span>
        <!-- <span>
          {{
            data.row.States == 1
              ? "待接收"
              : data.row.States == 2
              ? "维修中"
              : data.row.States == 3
              ? "已返回"
              : data.row.States == 4
              ? "已完成"
              : "已撤单"
          }}
        </span> -->
      </template>
      <template v-slot:tabelTitleLeft>
        <div>报修申请列表</div>
      </template>

      <template v-slot:condition style="height: 200px">
        <text-field
          v-model:value="conditionData.compid"
          labelText="客户:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguName"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.BrandId"
          labelText="品牌名称:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguBrand"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.proid"
          labelText="产品类别:"
          ref="selectChild"
          :clearable="true"
          :type="selectChildData == null ? 'select' : 'selectChild'"
          :selectChildData="selectChildData"
          :selectRemoteSearchData="selectOuguNameProduct"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.moid"
          labelText="产品型号:"
          ref="selectChildMoid"
          :clearable="true"
          :type="selectChildMoidData == null ? 'select' : 'selectChild'"
          :selectChildData="selectChildMoidData"
          :selectRemoteSearchData="selectOuguNameModelSelect"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.sn"
          labelText="SN号:"
          :clearable="true"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.statetime"
          type="date"
          labelText="申请起始日期:"
          clearable
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.endtime"
          type="date"
          labelText="申请截至日期:"
          clearable
          class="condition-container-input"
        >
        </text-field>
      </template>
      <template v-slot:oprator="$opData">
        <div class="opration">
          <del-button
            class="item"
            :useConfirm="true"
            comfirmMessage="确定删除吗？"
            comfirmOkText="确定"
            comfirmCancelText="取消"
            @buttonClick="delSingleUser($opData.data)"
            >删除</del-button
          >
        </div>
      </template>
    </tabel-panel>

    <pop-dialog
      id="loadBOX"
      @confirmClick="popUploadClick"
      v-if="loadShow"
      ref="getMenuList"
      :meta="popDialogList"
      detailShowType="data"
      @dialogClose="loadShow = false"
    >
      <div class="oprationTree">
        <div class="detailed-box">
          <!-- <div class="detailed-title">报修明细</div> -->
          <el-tabs v-model="activeName" type="card" @tab-click="">
            <el-tab-pane label="客户信息" name="first">
              <div style="display: flex; flex-wrap: wrap">
                <text-field
                  v-model:value="rowData.CompName"
                  labelText="客户名称:"
                  :clearable="true"
                  type="text"
                  :readOnly="true"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.LinkMan"
                  labelText="联系人:"
                  :clearable="true"
                  type="text"
                  :readOnly="true"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.TelNo"
                  labelText="电话:"
                  :clearable="true"
                  type="text"
                  :readOnly="true"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CompCode"
                  labelText="手机:"
                  :clearable="true"
                  type="text"
                  :readOnly="true"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.FaxNo"
                  labelText="传真:"
                  :clearable="true"
                  type="text"
                  :readOnly="true"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.Email"
                  labelText="Email:"
                  :clearable="true"
                  type="text"
                  :readOnly="true"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.PostNo"
                  labelText="邮编:"
                  :clearable="true"
                  type="text"
                  :readOnly="true"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  style="width: 100%"
                  v-model:value="rowData.Address"
                  labelText="地址:"
                  :clearable="true"
                  type="textarea"
                  :readOnly="true"
                  class="condition-container-input"
                >
                </text-field>
              </div>
            </el-tab-pane>
            <el-tab-pane label="设备信息" name="second">
              <div style="display: flex; flex-wrap: wrap">
                <text-field
                  v-model:value="rowData.RMANo"
                  labelText="RMA:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.BrandId"
                  labelText="品牌:"
                  :clearable="true"
                  type="select"
                  :selectRemoteSearchData="selectOuguBrand"
                  @change="selectOuguNameProduct"
                  class="condition-container-input"
                >
                </text-field>

                <text-field
                  v-model:value="rowData.ProCateId"
                  labelText="类别:"
                  ref="selectChild"
                  :clearable="true"
                  :type="selectChildData == null ? 'select' : 'selectChild'"
                  :selectChildData="selectChildData"
                  :selectRemoteSearchData="selectOuguNameProduct"
                  @change="selectOuguNameModelSelect"
                  class="condition-container-input"
                >
                </text-field>

                <text-field
                  v-model:value="rowData.ModelNoName"
                  labelText="型号:"
                  ref="selectChildMoid"
                  :clearable="true"
                  :type="selectChildMoidData == null ? 'select' : 'selectChild'"
                  :selectChildData="selectChildMoidData"
                  :selectRemoteSearchData="selectOuguNameModelSelect"
                  @change="selectModelNoName"
                  class="condition-container-input"
                >
                </text-field>
                <!-- <text-field
                  v-model:value="rowData.ProCateName"
                  labelText="类别:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.ModelNoName"
                  labelText="型号:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field> -->
                <text-field
                  v-model:value="rowData.SerialNoName"
                  labelText="SN号:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.AttachName"
                  labelText="附件:"
                  :clearable="true"
                  type="textarea"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CusApp"
                  labelText="系统信息标:"
                  :clearable="true"
                  type="textarea"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.Appendix"
                  labelText="备注:"
                  :clearable="true"
                  type="textarea"
                  class="condition-container-input"
                >
                </text-field>
              </div>
            </el-tab-pane>
            <el-tab-pane label="客户货运信息" name="third">
              <div style="display: flex; flex-wrap: wrap">
                <text-field
                  v-model:value="rowData.CusTransferNo"
                  labelText="货运单号:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  labelText="货运公司:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                  <template v-slot:rightInput>
                    <el-select
                      v-model="rowData.CusTransferCompId"
                      placeholder="请选货运公司"
                      size="small"
                    >
                      <el-option
                        v-for="(item, index) in selectDataComp"
                        :key="index"
                        :label="item.Name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </template>
                </text-field>
                <text-field
                  labelText="运输方法:"
                  class="condition-container-input"
                >
                  <template v-slot:rightInput>
                    <el-select
                      v-model="rowData.CusConveyanceId"
                      placeholder="请选运输方式"
                      size="small"
                    >
                      <el-option
                        v-for="(item, index) in selectDataMeth"
                        :key="index"
                        :label="item.Name"
                        :value="item.Id"
                      >
                      </el-option>
                    </el-select>
                  </template>
                </text-field>
                <text-field
                  v-model:value="rowData.CusTransferDate"
                  labelText="寄送时间:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field labelText="递送方式:">
                  <template v-slot:rightInput>
                    <el-select
                      v-model="rowData.NotExpress_Id"
                      placeholder="请选择寄送方式"
                      size="small"
                    >
                      <el-option
                        v-for="(item, index) in selectData"
                        :key="index"
                        :label="item.Name"
                        :value="item.Id"
                      >
                      </el-option>
                    </el-select>
                  </template>
                </text-field>
                <text-field
                  v-model:value="rowData.CusNote"
                  labelText="备注:"
                  :clearable="true"
                  type="textarea"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  style="width: 100%"
                  v-model:value="rowData.CusAddress"
                  labelText="邮寄地址:"
                  :clearable="true"
                  type="textarea"
                  class="condition-container-input"
                >
                </text-field>
              </div>
            </el-tab-pane>
            <el-tab-pane label="返回货运信息" name="fourth">
              <div style="display: flex; flex-wrap: wrap">
                <text-field
                  v-model:value="rowData.TransferNo"
                  labelText="货运单号:"
                  :clearable="true"
                  type="text"
                  :readOnly="true"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.TransferCompName"
                  labelText="货运公司:"
                  :clearable="true"
                  type="text"
                  :readOnly="true"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.ConveyanceName"
                  labelText="运输方法:"
                  :clearable="true"
                  type="text"
                  :readOnly="true"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.TransferDate"
                  labelText="寄送时间:"
                  :clearable="true"
                  type="text"
                  :readOnly="true"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.Note"
                  labelText="备注:"
                  :clearable="true"
                  type="textarea"
                  :readOnly="true"
                  class="condition-container-input"
                >
                </text-field>
              </div>
            </el-tab-pane>
          </el-tabs>
          <!-- <div class="pop-dialogClose" @click="handleClick">
            <i class="el-icon-close"></i>
          </div> -->
        </div>
      </div>
      <template v-slot:popFooter>
        <span> </span>
        <!-- <cancel-button
          class="pop-dialog-footer-button"
          @buttonClick="dialogFinish"
          >保存
        </cancel-button>
        <cancel-button
          class="pop-dialog-footer-button"
          @buttonClick="closeDialog"
          >取消
        </cancel-button>
        <del-button class="pop-dialog-footer-button" @buttonClick="dialogDel"
          >删除
        </del-button> -->
      </template>
    </pop-dialog>
  </div>
</template>

<script>
import cancelButton from "@/components/cancelButton.vue";
import textField from "@/components/textField.vue";
import delButton from "@/components/delButton.vue";
import addButton from "@/components/addButton.vue";
import downloadButton from "@/components/downloadButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import { downloadExcel } from "@/util/download.js";
import {
  ApplyDetailUpdate,
  ApplyDetailDelete,
  symptomDel,
} from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";

export default {
  name: "CusRepairList",
  components: {
    textField,
    addButton,
    delButton,
    tabelPanel,
    popDialog,
    downloadButton,
    cancelButton,
  },
  data() {
    const selectValueFn1 = (v, item) => {
      if (item) {
        return item.BrandId;
      }
    };
    const selectRemoteSearchData1 = async () => {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    };

    const selectRemoteSearchData = async (
      pageSize,
      currentPageIndex,
      parms
    ) => {
      if (parms.ProductId == null || parms == null) {
        return {
          total: 0,
          data: null,
        };
      }
      let source = await tableApi.modelSelect({
        ProductCategoryId: parms.ProductId,
      });
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    };

    const selectRemoteSearchData2 = async (
      pageSize,
      currentPageIndex,
      parms
    ) => {
      //产品select列表
      if (parms.BrandId == null || parms == null) {
        return {
          total: 0,
          data: null,
        };
      }
      let source = await tableApi.ProductSelect({ Bid: parms.BrandId });
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    };
    return {
      inputValue: "明细",
      activeName: "second",
      loadShow: false,
      rowData: null,
      rowTemplate: [
        {
          headerLabel: "维修状态",

          slot: "maintenanceState",
          // dataIndex: "State"
        },
        {
          headerLabel: "递送方式",
          sortable: true,
          dataIndex: "NotExpressName",
        },
        {
          headerLabel: "产品",
          sortable: true,
          dataIndex: "ProCateName",
        },
        {
          headerLabel: "型号",
          sortable: true,
          dataIndex: "ModelNoName",
        },
        {
          headerLabel: "SN号",
          sortable: true,
          dataIndex: "SerialNoName",
          dataRender: (v, { $index, column, row }) => {
            return (
              '<span style="color:' +
              (row.Distinguish == 1
                ? "green"
                : row.Distinguish == 2
                ? "blue"
                : row.Distinguish == 3
                ? "red"
                : "") +
              '">' +
              v +
              ""
            );
          },
        },
        {
          headerLabel: "症状信息",
          dataIndex: "CusApp",
        },
        {
          headerLabel: "备注",
          dataIndex: "IllDesc",
        },
        {
          headerLabel: "客户名称", //0
          sortable: true,
          dataIndex: "CompName",
        },
        {
          headerLabel: "申请日期",
          dataIndex: "AddDate",
          sortable: true,
        },
      ],
      conditionData: {
        compid: null,
        BrandId: null,
        proid: null,
        moid: null,
        sn: null,
        staetime: null,
        endtime: null,
      },
      selectChildData: null,
      selectChildMoid: null,
      selectChildMoidData: null,
      // 维修中心
      selectDataSer: [],
      //货运公司
      selectDataComp: [],
      //运输方法
      selectDataMeth: [],
      //寄送方式
      selectData: [],
      inputID: {
        brandId: null,
        proId: null,
        moId: null,
        sn: null,
      },
    };
  },
  watch: {
    "conditionData.BrandId"(newV, oldV) {
      this.$refs.selectChild.stringValue = "";
      if (newV) {
        this.selectOuguNameProduct(newV);
        return;
      }
      this.selectChildData = null;
    },
    "conditionData.proid"(newV, oldV) {
      this.$refs.selectChildMoid.stringValue = "";
      if (newV) {
        this.selectOuguNameModelSelect(newV);
        return;
      }
      this.selectChildMoidData = null;
    },
    // "conditionData.moid"(newV, oldV) {
    //   this.$refs.selectChildMoid.stringValue = "";
    //   if (newV) {
    //     this.selectOuguNameModelSelect(newV);
    //     return;
    //   }
    //   this.selectChildMoid = null;
    // },
  },
  methods: {
    /**
     * @description: 获取下拉框客户数据
     * @param {*}
     * @return {*}
     */
    async selectOuguName() {
      let source = await tableApi.CompanyInfoRole();
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    /**
     * @description: 三级联动 平拍名称
     * @param {*}
     * @return {*}
     */
    async selectOuguBrand() {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    /**
     * @description: 三级联动产品类别
     * @param {*} newV 品牌名称id
     * @return {*}
     */
    async selectOuguNameProduct(newV) {
      let source;
      if (this.selectChildData == null) {
        source = await tableApi.ProductSelect();
      } else {
        source = await tableApi.ProductSelect({ Bid: newV });
      }

      this.selectChildData = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    /**
     * @description: 三级联动产品型号
     * @param {*} ProductCategoryId---产品列别id
     * @return {*}
     */
    async selectOuguNameModelSelect(ProductCategoryId) {
      let source;
      if (!ProductCategoryId) {
        source = await tableApi.modelSelect();
      } else {
        source = await tableApi.modelSelect({ ProductCategoryId });
      }
      this.selectChildMoidData = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    selectModelNoName(aaaa) {
      this.rowData.ModelNo_Id = aaaa;
    },
    companyAdd() {
      //货运公司 TransComp
      tableApi.TransComp().then((data) => {
        if (data.code == 0) {
          this.selectDataComp = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
      //运输方法 TransMethod
      tableApi.TransMethod().then((data) => {
        if (data.code == 0) {
          this.selectDataMeth = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
      // 寄送方式 TransFangshi
      tableApi.TransFangshi().then((data) => {
        if (data.code == 0) {
          this.selectData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 重新获取表格数据
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    /**
     * @description: 删除--根据选择行的id
     * @param {*}
     * @return {*}
     */
    delSingleUser({ row, columnIndex, $index }) {
      let id = row.id;
      symptomDel({ id }).then((data) => {
        if (data.code == 0) {
          successMsg(data.message);
          this.reloadData();
        } else {
          errMsg(data.message);
        }
      });
    },
    //弹层事件
    popConfirmButtonClick({ slotData }) {
      console.log(slotData);
    },
    /**
     * @description: 双击事件
     * @param {*} row--某一行数据
     * @return {*}
     */
    customerRowDblClick(row) {
      console.log("row:", row);
      this.loadShow = true;
      this.rowData = row;
      this.$nextTick(() => {
        this.$refs.getMenuList.showPopDialog(row, "报修明细", "slot");
      });
      console.log("row:", this.rowData);
    },
    // 关闭弹出框
    handleClick(tab, event) {
      // console.log(tab, event);
      this.loadShow = false;
    },
    closeDialog() {
      this.loadShow = false;
      this.reloadData();
    },
    dialogDel() {
      let storageRoleId = window.localStorage.getItem("RoleId");
      if (storageRoleId != 1) {
        errMsg("没有权限");
        return;
      }
      ApplyDetailDelete({ Id: this.rowData.Id }).then((data) => {
        if (data.code == 0) {
          successMsg(data.message);
          this.closeDialog();
        } else {
          errMsg(data.message);
        }
      });
    },
    dialogFinish() {
      let storageRoleId = window.localStorage.getItem("RoleId");
      if (storageRoleId != 1) {
        errMsg("没有权限");
        return;
      }
      // api/ApplyRepairCommit/ApplyDetailUpdate post
      let infoObj = {
        detail: {
          // RMA
          RMANo: this.rowData.RMANo,
          // SN号SerialNoName
          ModelNoId: Number(this.rowData.ModelNo_Id),
          // SN号SerialNoName
          SerialNoName: this.rowData.SerialNoName,
          // 附件AttachName
          AttachName: this.rowData.AttachName,
          // 系统信息标 CusApp
          CusApp: this.rowData.CusApp,
          // 备注 NotExpress Id"
          Appendix: this.rowData.Appendix,
        },
        info: {
          // 货运单号:
          TransferNo: this.rowData.CusTransferNo,
          // 货运公司 CusTransfercompHame
          TranCompId: this.rowData.CusTransferCompId,
          // 运输方法CusConveyanceName
          ConveyanceId: this.rowData.CusConveyanceId,
          // 寄送时间 CusTransferDate
          TranDate: this.rowData.CusTransferDate,
          // 递送方式 NotExpress Id"
          NotExpressId: this.rowData.NotExpress_Id,
          // 备注  CusNote
          CusNote: this.rowData.CusNote,
          // 邮寄地址  CusAddress
          CusAddress: this.rowData.CusAddress,
          Id: this.rowData.Id,
        },
      };
      let obj = JSON.stringify(infoObj);
      ApplyDetailUpdate({ ...infoObj.detail, ...infoObj.info }).then((data) => {
        if (data.code == 0) {
          successMsg(data.message);
          this.closeDialog();
        } else {
          errMsg(data.message);
        }
      });
      console.log("finish", obj);
    },
    // 导出
    exportAlls() {
      tableApi
        .RepairComplateDaoChuState({
          page: 1,
          limit: 20,
          ...this.conditionData,
        })
        .then((data) => {
          downloadExcel(data, "维修状态");
        });
    },
  },
  created() {
    this.companyAdd();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

#suerSwitch .el-switch__core {
  width: 26px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: red;
}

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 270px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        margin-left: 10px;
      }
    }
  }
  .menuPowerBtn {
    // color:rgb(255, 255, 255)!important;
    // background:rgb(100,134,232)!important;
  }
  .menuPowerBOX {
    .el-button--default {
      width: 90px;
      height: 30px;
      color: #ffffff;
      background: rgb(100, 134, 232);
      border-radius: 4px;
    }
    .item {
      height: 30px;
      color: #ffffff !important;
      padding: 10px 15px !important;
      background: rgb(100, 134, 232) !important;
    }
  }
  //   #loadBOX {
  //     width: 50%;
  //     height: 50%;
  //   }
  .pop-dialog-conver {
    background: yellow;
  }
  .pop-dialog-container {
  }
  .oprationTree {
    background-color: #ecf5ff;
    // position: absolute;
    // width: 50%;
    // height: 50%;
    // top: 0;
    // left: 0;
    // padding: 5px;

    .detailed-box {
      //   width: 100%;
      height: 400px;
      //   border: 1px solid #99bce8;
      //   background-color: #f4f7f6;
      //   border-radius: 10px;

      .detailed-title {
        font-family: Microsoft YaHei;
        font-weight: normal;
        padding: 10px;
      }

      .text-field-container {
        background: #f4f7f6 !important;
        margin: 5px 20px;
        width: 320px;
      }
      .user-management-container .condition-container-input {
        margin: 5px 10px;
      }
    }
    // .pop-dialogClose {
    //   position: absolute;
    //   top: 20px;
    //   right: 20px;

    //   .el-icon-close:before {
    //     font-size: 28px;
    //   }
    // }
  }
  //   .pop-dialog-conver {
  //     display: block !important;
  //     width: 100% !important;
  //     height: 100% !important;
  //   }
}
// ::v-deep .select-trigger {
//   width: 100% !important;
// }
// ::v-deep .pop-dialog-footer-button {
//   margin: 0 10px;
// }
// ::v-deep .pop-dialog-container {
//   transform: none !important;
// }
</style>
